import { useState } from "react";
import styles from "./Summary.module.scss";
import cn from "classnames";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  Stack,
  StepConnector,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ExpandMore, HourglassEmpty } from "@mui/icons-material";
import {
  dateFormatter,
  dateTimeFormatter,
  formatDate,
  truncateString,
} from "../../../../helpers/formatter";

import DataTable from "../../../../elements/CustomDataTable/DataTable";
import _sendAPIRequest from "../../../../helpers/api";
import { PortalApiUrls } from "../../../../helpers/api-urls/PortalApiUrls";
import { products_Column } from "../../../../elements/CustomDataTable/PortalColumnData";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import ProductSpecificationModal from "../../../../elements/CustomModal/ProductSpecificationModal";
import {
  CheckCircleOutlined,
  CancelOutlined,
  GroupAdd,
} from "@mui/icons-material";
import { Step, StepLabel, Stepper } from "@mui/material";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../../../store/tabSlice";
import DOMPurify from "../../../../utils/DomPurifier";
const Summary = ({ bidDetails }) => {
  const [showSpecification, setShowSpecification] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile screens
  const type = new URLSearchParams(useLocation().search).get("type");

  const productsColumns = products_Column({
    setShowSpecification,
    setSelectedProduct,
  });

  const handleViewRequestClick = (tabvalue) => {
    dispatch(setActiveTab(tabvalue)); // Set the active tab
  };

  let steps = [];
  if (bidDetails.type === "L1") {
    steps = [
      {
        label: "Commercial Bid Invite",
        icon: (
          <GroupAdd
            style={{
              color: `${
                bidDetails?.participant?.status === "accepted" ||
                bidDetails?.participant?.status === "declined" ||
                bidDetails?.participant?.status === "revoked" ||
                bidDetails?.participant?.status === "pending" ||
                bidDetails?.participant?.status === "participated" ||
                bidDetails?.participant?.status === "awarded"
                  ? "green"
                  : "#FFC107"
              }`,
            }}
          />
        ),
        status: "complete",
      },
      {
        label: `${
          bidDetails?.participant?.status === "accepted" ||
          bidDetails?.participant?.status === "participated" ||
          bidDetails?.participant?.status === "awarded"
            ? "Accepted"
            : bidDetails?.participant?.status === "declined"
            ? "Declined"
            : bidDetails?.participant?.status === "revoked"
            ? "Accepted"
            : "Pending"
        }`,
        icon:
          bidDetails?.participant?.status === "accepted" ||
          bidDetails?.participant?.status === "participated" ||
          bidDetails?.participant?.status === "awarded" ? (
            <CheckCircleOutlined style={{ color: "green" }} />
          ) : bidDetails?.participant?.status === "declined" ? (
            <CancelOutlined style={{ color: "red" }} />
          ) : bidDetails?.participant?.status === "revoked" ? (
            <CheckCircleOutlined style={{ color: "green" }} />
          ) : (
            <HourglassEmpty style={{ color: "#FFC107" }} />
          ),
        status: "complete",
      },
      ...(bidDetails?.participant?.status === "revoked"
        ? [
            {
              label: "Revoked",
              icon: <CancelOutlined style={{ color: "red" }} />,
              status: "error",
            },
          ]
        : []),
      ...(bidDetails?.status === "cancelled"
        ? [
            {
              label: "Cancelled",
              icon: <CancelOutlined style={{ color: "red" }} />,
              status: "error",
            },
          ]
        : []),
      ...(bidDetails?.participant?.status === "participated" ||
      bidDetails?.participant?.status === "awarded"
        ? [
            {
              label: "Participated",
              icon: <CheckCircleOutlined style={{ color: "green" }} />,
              status: "success",
            },
          ]
        : []),
      ...(bidDetails?.participant?.status === "awarded"
        ? [
            {
              label: "Awarded",
              icon: <CheckCircleOutlined style={{ color: "green" }} />,
              status: "success",
            },
          ]
        : []),
      ...(bidDetails?.status === "completed" &&
      bidDetails?.participant?.status !== "awarded" &&
      bidDetails?.participant?.status !== "declined" &&
      bidDetails?.participant?.status !== "pending"
        ? [
            {
              label: "Not Awarded",
              icon: <CancelOutlined style={{ color: "red" }} />,
              status: "error",
            },
          ]
        : []),
    ];
  } else {
    steps = [
      {
        label: "Sample Bid Invited",
        icon: (
          <GroupAdd
            style={{
              color: `${
                bidDetails?.participant?.status === "accepted" ||
                bidDetails?.participant?.status === "declined" ||
                bidDetails?.participant?.status === "revoked" ||
                bidDetails?.participant?.status === "pending" ||
                bidDetails?.participant?.status === "participated" ||
                bidDetails?.participant?.status === "awarded"
                  ? "green"
                  : "grey"
              }`,
            }}
          />
        ),
        status: "complete",
      },
      {
        label: `${
          bidDetails?.participant?.sample?.invite_status === "accepted"
            ? "Accepted"
            : bidDetails?.participant?.sample?.invite_status === "declined"
            ? "Declined"
            : bidDetails?.participant?.status === "revoked"
            ? "Accepted"
            : "Pending"
        }`,
        icon:
          bidDetails?.participant?.sample?.invite_status === "accepted" ? (
            <CheckCircleOutlined style={{ color: "green" }} />
          ) : bidDetails?.participant?.sample?.invite_status === "declined" ? (
            <CancelOutlined style={{ color: "red" }} />
          ) : bidDetails?.participant?.status === "revoked" ? (
            <CheckCircleOutlined style={{ color: "green" }} />
          ) : (
            <HourglassEmpty style={{ color: "#FFC107" }} />
          ),
        status: "complete",
      },
      ...(bidDetails?.participant?.sample?.invite_status === "declined"
        ? []
        : [
            {
              label: `${
                bidDetails?.participant?.sample?.approval_status === "approved"
                  ? "Sample Approved"
                  : bidDetails?.participant?.sample?.approval_status ===
                    "rejected"
                  ? "Sample Rejected"
                  : "Sample Pending"
              }`,
              icon:
                bidDetails?.participant?.sample?.approval_status ===
                "approved" ? (
                  <CheckCircleOutlined style={{ color: "green" }} />
                ) : bidDetails?.participant?.sample?.approval_status ===
                  "rejected" ? (
                  <CancelOutlined style={{ color: "red" }} />
                ) : (
                  <HourglassEmpty style={{ color: "#FFC107" }} />
                ),
              status: "complete",
            },
            ...(bidDetails?.participant?.sample?.approval_status === "rejected"
              ? []
              : [
                  {
                    label: "Commercial Bid Invite",
                    icon:
                      bidDetails?.participant?.sample?.approval_status ===
                        "approved" && bidDetails?.bid_open_date !== null ? (
                        <GroupAdd style={{ color: "green" }} />
                      ) : (
                        <HourglassEmpty style={{ color: "#FFC107" }} />
                      ),
                    status: "complete",
                  },
                  {
                    label:
                      bidDetails?.participant?.status === "pending"
                        ? "Pending"
                        : bidDetails?.participant?.status === "accepted" ||
                          bidDetails?.participant?.status === "revoked" ||
                          bidDetails?.participant?.status === "participated" ||
                          bidDetails?.participant?.status === "awarded"
                        ? "Accepted"
                        : bidDetails?.participant?.status === "declined"
                        ? "Declined"
                        : "Pending",
                    icon:
                      bidDetails?.participant?.status === "pending" ? (
                        <HourglassEmpty style={{ color: "#FFBF00" }} />
                      ) : bidDetails?.participant?.status === "accepted" ||
                        bidDetails?.participant?.status === "revoked" ||
                        bidDetails?.participant?.status === "participated" ||
                        bidDetails?.participant?.status === "awarded" ? (
                        <CheckCircleOutlined style={{ color: "green" }} />
                      ) : bidDetails?.participant?.status === "declined" ? (
                        <CancelOutlined style={{ color: "red" }} />
                      ) : (
                        <HourglassEmpty style={{ color: "#FFBF00" }} />
                      ),
                    status: "complete",
                  },
                ]),
          ]),
      ...(bidDetails?.participant?.status === "revoked"
        ? [
            {
              label: "Revoked",
              icon: <CancelOutlined style={{ color: "red" }} />,
              status: "error",
            },
          ]
        : []),
      ...(bidDetails?.status === "cancelled"
        ? [
            {
              label: "Cancelled",
              icon: <CancelOutlined style={{ color: "red" }} />,
              status: "error",
            },
          ]
        : []),
      ...(bidDetails?.participant?.status === "participated" ||
      bidDetails?.participant?.status === "awarded"
        ? [
            {
              label: "Participated",
              icon: <CheckCircleOutlined style={{ color: "green" }} />,
              status: "success",
            },
          ]
        : []),
      ...(bidDetails?.participant?.status === "awarded"
        ? [
            {
              label: "Awarded",
              icon: <CheckCircleOutlined style={{ color: "green" }} />,
              status: "success",
            },
          ]
        : []),
      ...(bidDetails?.status === "completed" &&
      // 🔹 L1 BID: vendor live bid me aaya but award nahi hua
      ((bidDetails?.type === "L1" &&
        (bidDetails?.participant?.status === "accepted" ||
          bidDetails?.participant?.status === "participated")) ||
        // 🔹 QCBS BID: sample accept hua + live bid me aaya but award nahi hua
        (bidDetails?.type === "QCBS" &&
          bidDetails?.participant?.sample?.invite_status === "accepted" &&
          (bidDetails?.participant?.status === "accepted" ||
            bidDetails?.participant?.status === "participated"))) &&
      bidDetails?.participant?.status !== "awarded"
        ? [
            {
              label: "Not Awarded",
              icon: <CancelOutlined style={{ color: "red" }} />,
              status: "error",
            },
          ]
        : []),
    ];
  }
  const chatWithBuyer = async () => {
    try {
      const response = await _sendAPIRequest(
        "POST",
        `${PortalApiUrls.START_CHAT_WITH_BUYER}${bidDetails?.company?.id}/get_or_create/`,
        "",
        true
      );
      if (response?.status === 200) {
        navigate("/portal/messages", { state: { chatId: response.data.id } });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {type === "invited" ? (
        <Box
          key="3"
          sx={{
            width: "100%",
            fontSize: "0.8rem",
            lineHeight: 1.2,
            overflowX: isSmallScreen ? "auto" : "visible", // horizontal scroll on mobile
          }}
        >
          <Stepper
            alternativeLabel={!isSmallScreen} // switch to vertical if needed
            nonLinear
            activeStep={2} // Set active step index
            sx={{
              padding: "0.5rem",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: isSmallScreen ? "1rem" : "0",
              minWidth: isSmallScreen ? "600px" : "auto", // Prevent breaking layout
            }}
          >
            {steps.map((step, index) => {
              const iconColor = step.icon.props.style.color;

              return (
                <Step key={index}>
                  <StepLabel
                    icon={step.icon}
                    slotProps={{
                      stepIcon: {
                        sx: {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: isSmallScreen ? "1rem" : "inherit",
                        },
                      }
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <span
                        style={{
                          color: iconColor,
                          fontSize: isSmallScreen ? "0.7rem" : "0.8rem",
                          marginLeft: "8px",
                          whiteSpace: "nowrap",
                          display: isSmallScreen ? "none" : "inline", // 👈 Hide label on small screens
                        }}
                      >
                        {step.label}
                      </span>
                    </Box>
                  </StepLabel>
                  <StepConnector
                    sx={{
                      "& .MuiStepConnector-line": {
                        borderColor:
                          steps[index]?.icon?.props?.style?.color || "#d3d3d3", // Apply current step color
                        width: "100%", // Ensure it stretches properly
                      },
                      "&:first-of-type .MuiStepConnector-line": {
                        display: "none", // Hide the connector before the first step
                      },
                    }}
                  />
                </Step>
              );
            })}
          </Stepper>
        </Box>
      ) : null}
      {/* Summury */}
      <Accordion
        defaultExpanded
        square={true}
        classes={{
          root: `custom-accordion ${styles["bids-detail-accordion"]}`,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography classes={{ root: "custom-accordion-heading" }}>
            Summary
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="row">
            <div className="col">
              <h6 className={styles["col-heading"]}>Bid ID</h6>
              <p className={styles["col-data"]}>
                {bidDetails?.formatted_number}
              </p>
            </div>
            <Tooltip title={bidDetails?.title}>
              <div className="col">
                <h6 className={styles["col-heading"]}>Bid Title</h6>
                <p className={styles["col-data"]}>
                  {" "}
                  {truncateString(bidDetails?.title, 30)}
                </p>
              </div>
            </Tooltip>

            <div className="col">
              <h6 className={styles["col-heading"]}>Bid Type</h6>
              <p className={styles["col-data"]}>
                {bidDetails?.type}
                {bidDetails?.type === "L1"
                  ? " ( Commercial Bid )"
                  : " ( Quality & Cost Based Selection )"}
              </p>{" "}
            </div>
          </div>
          <Divider classes={{ root: "custom-divider" }} />
          <div className="row">
            <div className="col">
              <h6 className={styles["col-heading"]}>
                Bid Opening Date and Time
              </h6>
              <p className={styles["col-data"]}>
                {bidDetails?.bid_close_date
                  ? dateTimeFormatter(bidDetails?.bid_open_date)
                  : "-"}
              </p>
            </div>
            <div className="col">
              <h6 className={styles["col-heading"]}>
                Bid Closing Date and Time
              </h6>
              <p className={styles["col-data"]}>
                {bidDetails?.bid_close_date
                  ? dateTimeFormatter(bidDetails?.bid_close_date)
                  : "-"}
              </p>
            </div>
            <div className="col">
              <h6 className={styles["col-heading"]}>
                Bid Created Date and Time
              </h6>
              <p className={styles["col-data"]}>
                {`${dateTimeFormatter(bidDetails?.created_at)}`}
              </p>
            </div>
          </div>
          {bidDetails.type === "QCBS" && (
            <>
              <Divider classes={{ root: "custom-divider" }} />
              <div className="row">
                <div className="col">
                  <h6 className={styles["col-heading"]}>
                    Sample Receiving Opening Date
                  </h6>
                  <p className={styles["col-data"]}>
                    {bidDetails?.sample_receive_start_date
                      ? formatDate(bidDetails?.sample_receive_start_date)
                      : "-"}
                  </p>
                </div>
                <div className="col">
                  <h6 className={styles["col-heading"]}>
                    Sample Receiving Closing Date
                  </h6>
                  <p className={styles["col-data"]}>
                    {bidDetails?.sample_receive_end_date
                      ? formatDate(bidDetails?.sample_receive_end_date)
                      : "-"}
                  </p>
                </div>
                <div className="col"></div>
              </div>
            </>
          )}
          {type !== "invited" && (
            <>
              <Divider classes={{ root: "custom-divider" }} />
              <div className="row">
                <div className="col">
                  <h6 className={styles["col-heading"]}>
                    Total reserved price
                  </h6>
                  <p className={styles["col-data"]}>
                    ₹ {bidDetails?.total_reserved_price}
                  </p>
                </div>
                <div className="col">
                  <h6 className={styles["col-heading"]}>Total Bid amount</h6>
                  <p className={styles["col-data"]}>
                    ₹{" "}
                    {bidDetails?.total_bid_amount !== null
                      ? bidDetails?.total_bid_amount
                      : "-"}
                  </p>
                </div>
                <div className="col">
                  <h6 className={styles["col-heading"]}>Total Saving</h6>
                  <p className={styles["col-data"]}>
                    {" "}
                    ₹
                    {bidDetails?.total_bid_amount !== null
                      ? bidDetails?.total_reserved_price -
                        bidDetails?.total_bid_amount
                      : " -"}
                  </p>
                </div>
              </div>
            </>
          )}
        </AccordionDetails>
      </Accordion>
      {/* Description */}
      <Accordion
        defaultExpanded
        square={true}
        classes={{
          root: `custom-accordion ${styles["bids-detail-accordion"]}`,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography classes={{ root: "custom-accordion-heading" }}>
            Description
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {bidDetails?.amendment?.length > 0 &&
            bidDetails?.amendment
              ?.sort((latest, previous) => previous.id - latest.id)
              .map((amendment) => {
                if (amendment.field_name === "description") {
                  return (
                    <Accordion
                      defaultExpanded
                      square={true}
                      classes={{
                        root: `custom-accordion ${styles["bids-detail-accordion"]} ${styles["nested-accordion-heading"]}`,
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography
                          classes={{ root: "custom-accordion-heading" }}
                        >
                          Amendment ({dateTimeFormatter(amendment?.created_at)})
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="row">
                          <p
                            className={styles["col-data"]}
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(amendment.text),
                            }}
                          ></p>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                }
                return null;
              })}
          <div className="row">
            <div
              className={styles["col-data"]}
              style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(bidDetails?.description),
              }}
            ></div>
          </div>
        </AccordionDetails>
      </Accordion>
      {/* Delivery Terms  */}
      <Accordion
        defaultExpanded
        square={true}
        classes={{
          root: `custom-accordion ${styles["bids-detail-accordion"]}`,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography classes={{ root: "custom-accordion-heading" }}>
            Delivery Terms
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {bidDetails?.amendment?.length > 0 &&
            bidDetails?.amendment
              ?.sort((latest, previous) => previous.id - latest.id)
              .map((amendment) => {
                if (amendment.field_name === "delivery_terms") {
                  return (
                    <Accordion
                      defaultExpanded
                      square={true}
                      classes={{
                        root: `custom-accordion ${styles["bids-detail-accordion"]} ${styles["nested-accordion-heading"]}`,
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography
                          classes={{ root: "custom-accordion-heading" }}
                        >
                          Amendment ({dateTimeFormatter(amendment?.created_at)})
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="row">
                          <p
                            className={styles["col-data"]}
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(amendment.text),
                            }}
                          ></p>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                }

                return null;
              })}

          <div className="row">
            <p
              className={styles["col-data"]}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(bidDetails?.delivery_terms),
              }}
            ></p>
          </div>
        </AccordionDetails>
      </Accordion>
      {/* Payment Terms */}
      <Accordion
        defaultExpanded
        square={true}
        classes={{
          root: `custom-accordion ${styles["bids-detail-accordion"]}`,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography classes={{ root: "custom-accordion-heading" }}>
            Payment Terms
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {bidDetails?.amendment?.length > 0 &&
            bidDetails?.amendment
              ?.sort((latest, previous) => previous.id - latest.id)
              .map((amendment) => {
                if (amendment.field_name === "payment_terms") {
                  return (
                    <Accordion
                      defaultExpanded
                      square={true}
                      classes={{
                        root: `custom-accordion ${styles["bids-detail-accordion"]} ${styles["nested-accordion-heading"]}`,
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography
                          classes={{ root: "custom-accordion-heading" }}
                        >
                          Amendment ({dateTimeFormatter(amendment?.created_at)})
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="row">
                          <p
                            className={styles["col-data"]}
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(amendment.text),
                            }}
                          ></p>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  );
                }

                return null;
              })}
          <div className="row">
            <p
              className={styles["col-data"]}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(bidDetails?.payment_terms),
              }}
            ></p>
          </div>
        </AccordionDetails>
      </Accordion>
      {/* Eligibility Criteria */}
      {bidDetails?.eligiblity_criteria && (
        <Accordion
          defaultExpanded
          square={true}
          classes={{
            root: `custom-accordion ${styles["bids-detail-accordion"]}`,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography classes={{ root: "custom-accordion-heading" }}>
              Eligibility Criteria
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {bidDetails?.amendment?.length > 0 &&
              bidDetails?.amendment
                ?.sort((latest, previous) => previous.id - latest.id)
                .map((amendment) => {
                  if (amendment.field_name === "eligiblity_criteria") {
                    return (
                      <Accordion
                        defaultExpanded
                        square={true}
                        classes={{
                          root: `custom-accordion ${styles["bids-detail-accordion"]} ${styles["nested-accordion-heading"]}`,
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          <Typography
                            classes={{ root: "custom-accordion-heading" }}
                          >
                            Amendment (
                            {dateTimeFormatter(amendment?.created_at)})
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="row">
                            <p
                              className={styles["col-data"]}
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(amendment?.text),
                              }}
                            ></p>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    );
                  }

                  return null;
                })}
            <div className="row">
              <p
                className={styles["col-data"]}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(bidDetails?.eligiblity_criteria),
                }}
              ></p>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
      {/* Products list */}
      <Accordion
        defaultExpanded
        square={true}
        classes={{
          root: `custom-accordion ${styles["bids-detail-accordion"]}`,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography classes={{ root: "custom-accordion-heading" }}>
            Products
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DataTable
            propsColumn={productsColumns}
            propsData={bidDetails?.product || []}
          />
        </AccordionDetails>
      </Accordion>
      {/* Categories */}
      <Accordion
        defaultExpanded
        square={true}
        classes={{
          root: `custom-accordion ${styles["bids-detail-accordion"]}`,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography classes={{ root: "custom-accordion-heading" }}>
            Categories ({bidDetails?.category?.length})
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
              gap: "10px"
            }}>
            {bidDetails?.category?.map((category) => {
              return (
                <Chip label={category?.name} className={styles["categories"]} />
              );
            })}
          </Stack>
        </AccordionDetails>
      </Accordion>
      {/* Buyer */}
      {type === "invited" && (
        <Accordion
          defaultExpanded
          square={true}
          classes={{
            root: `custom-accordion ${styles["bids-detail-accordion"]}`,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography classes={{ root: "custom-accordion-heading" }}>
              Buyer
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={styles["accordion-details"]}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center"
              }}>
              <Avatar
                className={styles["buyer-avatar"]}
                alt="Buyer Image"
                src={
                  bidDetails?.company?.logo === null
                    ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRS4VAsurdDdyaWQ3h_FwC1MpAytWmY8_q0Ig&s"
                    : bidDetails?.company?.logo
                }
              />
              <NavLink
                className={styles["table-link"]}
                to={`/portal/companies/details/${bidDetails?.company?.id}`}
              >
                {bidDetails?.company?.name}
              </NavLink>
            </Box>
            <Button
              variant="contained"
              className={styles["chat-button"]}
              onClick={chatWithBuyer}
            >
              Chat with Buyer
            </Button>
          </AccordionDetails>
        </Accordion>
      )}
      {type === "invited" ? (
        <>
          <div className="container-fluid">
            <div className={styles["blue-container"]}>
              <div className={styles["note-header"]}>
                Note: Navigating Supplier Dashboard
              </div>
              <div className={styles["note-description"]}>
                As a supplier on Bidding Karo, you have access to a range of
                tools to help manage your interactions and track the status of
                your bids. Here's an overview of each panel:
              </div>
              <div className={cn("mt-3", styles["note-list"])}>
                <ul>
                  <li>
                    <strong
                      onClick={() => handleViewRequestClick(1)}
                      className={styles["navigator"]}
                    >
                      Documents Panel:
                    </strong>{" "}
                    View and download all documents uploaded by the buyer. This
                    panel keeps you informed of all bid-related documentation
                    you need for reference and compliance.
                  </li>
                  <li>
                    <strong
                      onClick={() => handleViewRequestClick(2)}
                      className={styles["navigator"]}
                    >
                      Acceptance Status:
                    </strong>{" "}
                    Monitor the status of your bid acceptance from the
                    supplier’s end. This panel shows whether your bid has been
                    accepted, rejected, or is still pending with the buyer.
                  </li>
                  <li>
                    <strong
                      onClick={() => handleViewRequestClick(3)}
                      className={styles["navigator"]}
                    >
                      Questions:
                    </strong>{" "}
                    Find questions from the buyer directed to you, the supplier.
                    Here, you can view and respond to buyer inquiries to ensure
                    clarity and enhance bid collaboration.
                  </li>
                  <li>
                    <strong
                      onClick={() => handleViewRequestClick(4)}
                      className={styles["navigator"]}
                    >
                      Remarks:
                    </strong>{" "}
                    Leave your remarks or feedback for the buyer regarding the
                    bid. This feature allows you to communicate any
                    observations, requests, or comments directly.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="container-fluid">
          <div className={styles["blue-container"]}>
            <div className={styles["note-header"]}>
              Note: Flexibility at Your Fingertips
            </div>
            <div className={styles["note-description"]}>
              At Bidding Karo, we understand that circumstances can change.
              That's why we've made it easy for you to manage your bids with
              complete flexibility:
            </div>
            <div className={cn("mt-3", styles["note-list"])}>
              <ul>
                <li>
                  <strong>Edit Bids:</strong> After creating a bid, you have a
                  24-hour window to make any necessary edits. Whether it's
                  adjusting the amount or changing the terms, ensure your bid is
                  just right within this time frame.
                </li>
                <li>
                  <strong>Make Amendments:</strong> Once the initial 24-hour
                  edit period is over, you can still make amendments for another
                  24 hours. This allows you to fine-tune your bid even further
                  before it becomes final.
                </li>
                <li>
                  <strong>Cancel Bids:</strong> If you need to withdraw your
                  bid, you can cancel it anytime before it goes live. You have
                  up to 24 hours to cancel the bid, giving you the flexibility
                  to reconsider your decisions.
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      {showSpecification && (
        <ProductSpecificationModal
          showSpecification={showSpecification}
          setShowSpecification={setShowSpecification}
          selectedProduct={selectedProduct}
        />
      )}
    </>
  );
};

export default Summary;
